import React, { useEffect } from 'react';
import styled from 'styled-components';

import { User } from '~/api/account/accountApiTypes';
import { PhoneConfirmationMethod } from '~/api/auth/authApiTypes';
import { Book } from '~/api/book/bookApiTypes';
import Modal from '~/atomic/molecula/Modal';
import { confirmPhone } from '~/feature/authorization/auth.data';
import { subscribeBookAndOpenModal } from '~/feature/book/SubscribeBookModal/subscribeBookModal.data';
import { subscribeBookModalSelector } from '~/feature/book/SubscribeBookModal/subscribeBookModal.selector';
import { subscribeBookModalActions } from '~/feature/book/SubscribeBookModal/subscribeBookModal.slice';
import { changeConfirmPhoneMethod } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.data';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { CodePhoneAuthForm } from '~/feature/finance/BuyingSteps/ChoosePay/CodePhoneAuthForm';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { GraphqlBook } from '~/graphql/books/factory/book/BookFactoryTypes';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

interface Props {
  book?: Partial<GraphqlBook> | Book;
}

export const CallPhoneAuthModalWithSubscribeBook = ({ book }: Props) => {
  const dispatch = useAppDispatch();
  const { confirmPhoneMethodWithSubscribeBook } = useAppSelector(subscribeBookModalSelector);
  const { quickAuthPhone } = useAppSelector(choosePaySelector);
  const isOpenCallPhoneAuthModal = confirmPhoneMethodWithSubscribeBook === 'flash-call';

  useEffect(() => {
    if (isOpenCallPhoneAuthModal) {
      ym('reachGoal', 'open-confirm-phone-modal');
    }
  }, [isOpenCallPhoneAuthModal]);

  const closeModal = () => {
    dispatch(subscribeBookModalActions.changeConfirmPhoneMethodWithSubscribeBook(''));
  };

  const onBackClick = () => {
    closeModal();
    dispatch(subscribeBookModalActions.setIsOpenAuthModalWithSubscribeBook(true));
  };

  const onChooseMethod = (method: PhoneConfirmationMethod) => {
    dispatch(changeConfirmPhoneMethod({
      method,
      changeMethod: () => {
        dispatch(subscribeBookModalActions.changeConfirmPhoneMethodWithSubscribeBook(method));
      },
    }));
  };

  const confirmSendCode = async (code: string) => {
    const result = await dispatch(confirmPhone({ code, afterLogin: async (user: User) => {} }));
    if (confirmPhone.fulfilled.match(result)) {
      closeModal();
      dispatch(subscribeBookAndOpenModal({ book }));
    }
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenCallPhoneAuthModal}
    >
      <CodePhoneAuthForm
        title="Введите последние 4 цифры входящего номера"
        description={(
          <>
            Звоним на
            {' '}
            <SCBold>
              +
              {quickAuthPhone}
            </SCBold>
            {' '}
            - отвечать не нужно
          </>
        )}
        nextButtonText="Продолжить"
        confirmSendCode={confirmSendCode}
        onChooseMethod={onChooseMethod}
        onBackClick={onBackClick}
      />
    </SCAuthModal>
  );
};

export const SCAuthModal = styled(Modal)`
  max-width: 458px;

  .ant-modal-body {
    padding-top: 23px;
    padding-bottom: 23px;
  }

  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;

const SCBold = styled.span`
  font-weight: 600;
  text-decoration: none;
`;
